import { render, staticRenderFns } from "./IncidentsTableView.vue?vue&type=template&id=7956f632"
import script from "./IncidentsTableView.vue?vue&type=script&lang=ts"
export * from "./IncidentsTableView.vue?vue&type=script&lang=ts"
import style0 from "./IncidentsTableView.vue?vue&type=style&index=0&id=7956f632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports